export const normalizeWhatsappProvider = (provider) => {
  if (!provider) {
    return "baileys";
  }

  if (["beta", "stable", "baileys"].includes(provider)) {
    return "baileys";
  }

  if (provider === "meta_cloud") {
    return "meta_cloud";
  }

  return provider;
};

export const isMetaCloudProvider = (provider) =>
  normalizeWhatsappProvider(provider) === "meta_cloud";

export const isBaileysProvider = (provider) =>
  normalizeWhatsappProvider(provider) === "baileys";

export const getWhatsappProviderLabel = (provider) =>
  isMetaCloudProvider(provider) ? "Oficial" : "Web";
